<template>
  <div class="detail-page">
    <BackNav :title="$t('order.detailTitle')" />
    <div class="body">
      <!-- 号码明细网格 -->
      <div class="section-title">{{ $t('order.detailTitle') }}</div>
      <div class="num-list" v-if="orderDetailList && orderDetailList.length">
        <div v-for="(item, i) in orderDetailList" :key="i" class="num-chip">
          <div class="n">{{ pad(item.num) }}</div>
          <div class="amts">
            <span class="m">M {{ item.mAmount }}</span>
            <span class="r" v-if="hasR && item.rAmount">R {{ item.rAmount }}</span>
          </div>
        </div>
      </div>
      <div v-else class="empty">
        <van-icon name="records" class="empty-icon" />
        <div>{{ $t('common.noData') }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { OrderService } from '@/services';
import BackNav from '@/components/BackNav';

const route = useRoute();
const orderDetailList = ref([]);
const pad = (n) => String(n).padStart(2, '0');
// 整单里有任一 R 金额就展示 R 提示
const hasR = computed(() => orderDetailList.value.some((x) => Number(x.rAmount) > 0));
const initOrderDetail = async () => {
  const { result } = await OrderService.getOrderDetailsApi(route.params.id);
  orderDetailList.value = result || [];
};
onMounted(() => {
  initOrderDetail();
});
</script>

<style lang="scss" scoped>
.detail-page {
  min-height: 100vh;
  background: var(--bg-page);
}
.body {
  padding: 20px 16px;
}
.section-title {
  font-size: 24px;
  color: var(--text-secondary);
  padding: 4px 4px 16px;
  font-weight: 500;
}

.num-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.num-chip {
  background: #fff;
  border-radius: 16px;
  padding: 20px 12px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  .n {
    font-size: 42px;
    font-weight: 700;
    color: var(--brand-secondary);
    font-family: 'Menlo', 'Consolas', monospace;
    line-height: 1.1;
    margin-bottom: 8px;
  }
  .amts {
    display: flex;
    justify-content: center;
    gap: 8px;
    font-size: 20px;
    .m {
      color: var(--brand-primary);
    }
    .r {
      color: #10b981;
    }
  }
}

.empty {
  text-align: center;
  color: var(--text-muted);
  padding: 120px 0;
  .empty-icon {
    font-size: 100px;
    margin-bottom: 16px;
    opacity: 0.5;
  }
  font-size: 26px;
}
</style>
